import React from 'react'
import { Box, Grid, IconButton, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { TariffAccordionItem } from '../../../wallboxes/components/assign-tariff/TariffAccordionItem'
import { Select } from '@e3dc-react/shell/Elements/Select'
import CloseIcon from '@mui/icons-material/Close'
import { useAccordionStyles } from 'src/Libs/e-mobility/shared/styles/accordion.styles'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AssignNewTariffButton } from 'src/Libs/e-mobility/wallboxes/components/assign-tariff/AssignNewTariffButton'
import { MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS } from '../../mock-data/mock-wallbox-with-assigned-tariff-and-tokens'
import { Trans } from 'react-i18next'
import { MOCK_INSTALLATION_ID, MOCK_VAT_RATE } from 'src/Libs/e-mobility/guided-tour/mock-data/mock-properties'

/** Wallbox assign tariff dialog step component */
export const AssignTariffToWallboxDialogStep: React.FC = () => {
  const { classes } = useAccordionStyles()
  const { t } = useCustomTranslation()
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down('sm'))

  return (
    <Box>
      <Trans i18nKey="emobility.tour.wallbox-assign-tariff-dialog" components={{ strong: <strong /> }} />

      <Paper
        component="div"
        sx={{
          mt: 2,
          pointerEvents: 'none',
          opacity: 0.9,
          boxShadow: '0 0 0 2px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.3)', // More dramatic shadow
          overflow: 'hidden',
          transform: 'scale(0.95)',
          filter: 'grayscale(5%)',
          backgroundColor: '#fff',
          padding: 4,
          paddingBottom: 6,
        }}
      >
        <Box sx={{ pointerEvents: 'none', width: '100%', marginTop: '20px' }}>
          <Typography fontWeight="bold" fontSize={isMobile ? 12 : undefined}>
            {t('emobility.wallbox.editTariffs.title', {
              wallbox: MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.wallboxName,
              id: MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.wallboxId,
            })}
          </Typography>

          <Box my={3}>
            <AssignNewTariffButton onAddTariff={() => undefined} />
          </Box>

          <Stack spacing={3}>
            <Stack className={classes.container}>
              <Grid container spacing={3} p={2} alignItems={'center'}>
                <Grid item xs={10}>
                  <Select
                    value={''}
                    label={t('emobility.wallbox.editTariffs.tariffSelectLabel')}
                    options={[{ value: '', label: 'Tariff 1' }]}
                    onChange={() => undefined}
                    useTooltipErrorMessage={false}
                    name="tariffs"
                  />
                </Grid>
                <Grid item xs={2} display={'flex'} alignSelf="start" justifyContent={'center'}>
                  <IconButton onClick={() => undefined} sx={{ height: isMobile ? 50 : undefined }}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>

              {/* There is a slight mismatch between the general TariffModel and the tariff structure returned inside the Wallbox response. */}
              {/* For this reason, we must apply some transformation to fill the remaining mock properties to be consumed by the accordion item component. */}
              {MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.activeTariff ? (
                <TariffAccordionItem
                  tariff={{
                    ...MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.activeTariff,
                    installationId: MOCK_INSTALLATION_ID,
                    staticPrices: {
                      gridPrice: MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.activeTariff.staticPrices.gridPrice,
                      solarPrice: MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.activeTariff.staticPrices.solarPrice,
                      vat: MOCK_VAT_RATE,
                    },
                    wallboxConnector: { SomeWallbox: '1' },
                    connectorId: '',
                    lastUpdated: '',
                    createdBy: '',
                  }}
                  wallboxType={MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS.wallboxType}
                />
              ) : null}
            </Stack>
          </Stack>
        </Box>
      </Paper>
    </Box>
  )
}
